import { setDiagramCluster as setDiagramClusterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    source?: String,
    discovery_rule_id?: String
}

export async function setDiagramCluster ({
    source,
    discovery_rule_id,
    eventEmitter,
}: Props) {
    setDiagramClusterDiagram(source,discovery_rule_id);
    eventEmitter.emit(Event.setDiagramCluster);
};
